import React from 'react'
import sumBy from 'lodash/sumBy'
import type { CustomerSalesReport } from './types'
import css from './customerSales.css'
import { i18n } from '../../index'
type Props = {
  data: Array<CustomerSalesReport>
  week: number | string
}

const WeekSummaryRow = ({ data, week }: Props) => (
  <tr className={css.weekSummaryRow}>
    <td>{`${i18n.t('common.weekShort')} ${week}`}</td>
    <td>{sumBy(data, 'salesVolume')}</td>
    <td>{Math.round(sumBy(data, 'salesAmount'))}</td>
    <td>{sumBy(data, 'target')}</td>
    <td>{sumBy(data, 'salesVolume') - sumBy(data, 'target')}</td>
    <td></td>
  </tr>
)

export default WeekSummaryRow
